import { SelectField } from "@homebound/beam";
import { isItivOrderField } from "src/routes/libraries/plan-package/takeoffs/utils";
import { useProductOfferingContext, useProductOfferingStore } from "../ProductOfferingScopeContext";
import { offeringItemTableSortByOptions } from "../utils";

// Copied from src/routes/libraries/plan-package/takeoffs/components/SortBySelectField.tsx
export function SortBySelectField() {
  const itemTableSortBy = useProductOfferingStore((state) => state.itemTableSortBy);
  const state = useProductOfferingContext();
  const setItemTableSortBy = state.getState().setItemTableSortBy;

  return (
    <SelectField
      label="Sort By"
      labelStyle="inline"
      getOptionLabel={(o) => o.name}
      getOptionValue={(o) => o.id}
      onSelect={(v) => v && isItivOrderField(v) && setItemTableSortBy(v)}
      options={offeringItemTableSortByOptions()}
      value={itemTableSortBy}
      sizeToContent
    />
  );
}
